import Vue2Filters from 'vue2-filters'
import VeeValidate from 'vee-validate'
import VuexComputed from 'utils/VuexComputed'

const pluginsAssociator = (Vue, plugins) => {
  _.each(plugins, ({ plugin, options = {} }) => {
    Vue.use(plugin, options)
  })
}


const pluginList = [
  // { plugin: VeeValidate, options: {} },
  { plugin: Vue2Filters },
  { plugin: VuexComputed }
]

export { pluginsAssociator, pluginList }



// WEBPACK FOOTER //
// ./client/utils/VuePluginHelper.js